module.exports = __webpack_public_path__ + "img/suitable.406ad6a1.svg";